import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { AppropriatenessTestFilterKey } from 'api/Clients/Types/AppropriatenessTestDto'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { CustomDateFilter, MultiCompanySelectFilter } from '../common.filter'
import { AppropriatenessTestCategoryFilter } from './AppropriatenessTestCategoryFilter'
import { AppropriatenessTestSubcategoryFilter } from './AppropriatenessTestSubcategoryFilter'

export const getAppropriatenessTestFields = (): FieldSettings[] => [
  {
    name: AppropriatenessTestFilterKey.name,
    label: 'Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: AppropriatenessTestFilterKey.category,
    label: 'Category',
    filter: AppropriatenessTestCategoryFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: AppropriatenessTestFilterKey.subCategory,
    label: 'Sub Category',
    filter: AppropriatenessTestSubcategoryFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: AppropriatenessTestFilterKey.tickmillCompany,
    label: 'Tickmill Company',
    filter: MultiCompanySelectFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: AppropriatenessTestFilterKey.dateCreated,
    label: 'Date Created',
    filter: CustomDateFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
]
